import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import generatePDFNew from './PurchaseHistoryInvoice';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { format } from 'date-fns';

const PurchaseHistoryView = () => {
    const { id } = useParams();
    const accessToken = localStorage.getItem('accessToken');
    const [productList, setProductList] = useState([]);
    const [supplierAddress, setSupplierAddress] = useState({});
    const [totals, setTotals] = useState({
        subtotal: 0,
        totalvat: 0,
        total: 0,
        totalQuantity: 0
    });
    const [weights, setWeights] = useState({
        gross_weight: 0,
        net_weight: 0,
        cbm: 0
    });

    const fetchData = async () => {
        const formData = new FormData();
        formData.append('id', id);
        const apiUrl = `${config.api_url}/ws-get-purchase-history-view`;
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });
            if (!response.ok) {
                throw new Error('Failed to fetch purchase data');
            }
            const data = await response.json();
            if (data?.status === 'error') {
                setProductList([]);
                setSupplierAddress({});
                return;
            }
            const products = Array.isArray(data?.products) ? data.products : [];
            setProductList(products);
            setSupplierAddress(data?.headerSection2 || {});
            
            // Calculate totals
            let subtotal = 0;
            let totalvat = 0;
            let totalQuantity = 0;
            let gross_weight = 0;
            let net_weight = 0;
            let cbm = 0;

            products.forEach(product => {
                const amount = calculateAmount(product.quantity, product.cost);
                const vat = calculateVAT(amount, product.rate);
                subtotal += amount;
                totalvat += vat;
                totalQuantity += Number(product.quantity);
                gross_weight += Number(product.gross_weight || 0);
                net_weight += Number(product.net_weight || 0);
                cbm += Number(product.cbm || 0);
            });

            setTotals({
                subtotal,
                totalvat,
                total: subtotal + totalvat,
                totalQuantity
            });

            setWeights({
                gross_weight,
                net_weight,
                cbm
            });

        } catch (error) {
            console.error('Error fetching purchase data:', error);
        }
    };

    useEffect(() => {
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }
        fetchData();
    }, []);

    const calculateAmount = (quantity, price) => {
        const qty = Number(quantity);
        const prc = Number(price);
        return isNaN(qty) || isNaN(prc) ? 0 : qty * prc;
    };
    const calculateVAT = (amount, rate) => {
        const amt = Number(amount);
        const r = Number(rate);
        return isNaN(amt) || isNaN(r) ? 0 : (amt * r) / 100;
    };

    const calculateTotalPrice = (quantity, price, rate) => {
        const amt = calculateAmount(quantity, price); // Ensure this returns a number
        const vat = calculateVAT(amt, rate); // Ensure this returns a number
        return isNaN(amt) || isNaN(vat) ? 0 : amt + vat; // Return 0 if either is NaN
    };

    const formatDate = (dateString) => {
        if (!dateString || dateString === '00-00-0000') return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB');
        } catch (error) {
            return dateString;
        }
    };

    const displayValue = (value) => {
        if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
            return '-';
        }
        return value;
    };

    const displayAddressValue = (value) => {
        if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
            return '';
        }
        return value;
    };

    const handleGeneratePurchaseInvoicePDF = (id) => {
        generatePDFNew(id, false, 'purchase');
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="/Dashboard">Dashboard</a> &gt; <span className="last-crumb">Purchase Order </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="show-order-area dashboard">
                        <div className="sales-view-area" style={{ width: '100%', border: 'none' }}>
                            <div className="row">
                                <div className="col-7">

                                    <button onClick={(e) => handleGeneratePurchaseInvoicePDF(id)}>
                                        Generate PDF
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-7">

                                </div>
                            </div>

                            <div className="row page-header" style={{ paddingTop: '10px' }}>
                                <div className="col-3">
                                    <h5>Star Pacific</h5>
                                    <p>Industrial Estate<br />Middlesex, London UB3 1AT<br />United Kingdom</p>
                                </div>
                                <div className="col-3">
                                    <ul>
                                        <li><b>Co. Reg. No :</b> 7298396</li>
                                        <li><span>VAT Reg. No.:</span> GB994533184</li>
                                        <li><span>Tel :</span> 44-208 329 3800</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row page-header" style={{ paddingTop: '10px' }}>
                                <div className="col-3">
                                    <ul>
                                        <li><b>Supplier Address : </b>  {displayValue(supplierAddress?.supplier_name)}</li>
                                        <li><span> {displayAddressValue(supplierAddress?.supplier_address_line1)}</span></li>
                                        <li><span> {displayAddressValue(supplierAddress?.supplier_address_line2)}</span></li>
                                        <li><span> {displayAddressValue(supplierAddress?.city)}</span></li>
                                        <li><span>{displayAddressValue(supplierAddress?.country)}{displayAddressValue(supplierAddress?.postcode)}</span></li>

                                    </ul>
                                </div>
                                <div className="col-3">
                                    <ul>
                                        <li><b>VAT Reg. No :</b> {displayValue(supplierAddress?.vat_id)}</li>
                                        <li><span>Rep : </span> {displayValue(supplierAddress?.contact_person_name)}</li>
                                        <li><span>Account No :</span> {displayValue(supplierAddress?.bank_account_number)}</li>
                                    </ul>
                                </div>
                                <div className="col-3">
                                    <ul>
                                        <li><span>PO No :</span>  {displayValue(supplierAddress?.reference_no)}</li>
                                        <li><span>Date : </span>  {formatDate(supplierAddress?.raised_on) || '-'}</li>
                                        <li><span>Job Ref :</span> {displayValue(supplierAddress?.job_ref)}</li>
                                    </ul>
                                </div>
                                <div className="col-3">
                                    <ul>
                                        <li><span>Currency :</span> {displayValue(supplierAddress?.currency_id)}</li>
                                        <li><span>Date of Arrival : </span> {formatDate(supplierAddress?.arrival_date) || '-'}</li>

                                        <li><span>SO# :</span> -</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row page-header" style={{ paddingTop: '10px' }}>
                                <div className="col-3">

                                    {supplierAddress?.delivery_type === 'collection' && (


                                        <ul>
                                            <li><b>Collection Address : </b> {displayValue(supplierAddress.supplier_name)}</li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line1)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line2)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcity)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whstate)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcountry)} {displayAddressValue(supplierAddress?.whpostcode)}</span></li>
                                        </ul>

                                    )}



                                    {(supplierAddress?.is_wharehouse_or_customer === 'warehouse' && supplierAddress?.delivery_type === 'delivery') && (

                                        <ul>
                                            <li><b>Delivery Address : </b></li>
                                            <li><span>{displayValue(supplierAddress?.warehouse_name)}</span></li>
                                            <li><span>{displayValue(supplierAddress?.reference_no)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line1)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line2)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcity)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whstate)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcountry)} {displayAddressValue(supplierAddress?.whpostcode)}</span></li>
                                        </ul>
                                    )}

                                    {(supplierAddress?.is_wharehouse_or_customer === 'customer' && supplierAddress?.delivery_type === 'delivery') && (

                                        <ul>
                                            <li><b>Customer Address : </b> {displayValue(supplierAddress?.name)}</li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line1)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.address_line2)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcity)}</span></li>
                                            <li><span>{displayValue(supplierAddress?.whstate)}</span></li>
                                            <li><span>{displayAddressValue(supplierAddress?.whcountry)} {displayAddressValue(supplierAddress?.whpostcode)}</span></li>
                                        </ul>
                                    )}




                                </div>
                                <div className="col-3">
                                </div>


                            </div>
                            <div className="sales-view-table">
                                <table className="table table-bordered" id="purchaseProforma">
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Line No</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>SKU Code</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Product Description</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Pack</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Size</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Unit Barcode</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Case Qty</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Unit Price</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Amount</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Vat Rate (%)</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Vat Amount</th>
                                            <th style={{ backgroundColor: '#eee9e9' }}>Total Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productList.map((product, index) => {
                                            const amount = calculateAmount(product.quantity, product.cost);
                                            const vat = calculateVAT(amount, product.rate);
                                            const totalPrice = calculateTotalPrice(product.quantity, product.cost, product.rate);

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                                                            <td>{displayValue(product.code)}</td>
                                        <td>{displayValue(product.product_desc)}</td>
                                        <td>{displayValue(product.pack)}</td>
                                        <td>{displayValue(product.size)}</td>
                                        <td>{displayValue(product.unit_barcode)}</td>
                                        <td>{displayValue(product.quantity)}</td>
                                        <td>{displayValue(product.cost)}</td>
                                                                                            <td><span>{amount.toFixed(2)}</span></td>
                                        <td>{displayValue(product.rate)}</td>
                                        <td><span>{vat.toFixed(2)}</span></td>
                                                    <td><span>{totalPrice.toFixed(2)}</span></td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                                            <td><span>{totals.totalQuantity}</span></td>
                                            <td></td>
                                            <td><span>{totals.subtotal.toFixed(2)}</span></td>
                                            <td></td>
                                            <td><span>{totals.totalvat.toFixed(2)}</span></td>
                                            <td><span>{totals.total.toFixed(2)}</span></td>
                                        </tr>
                                    </tfoot>

                                </table>

                            </div>

                            <div className="row page-header" style={{ paddingTop: '10px' }}>
                                <div className="col-7">
                                    <ul>
                                        {supplierAddress?.delivery_notes && (
                                            <li><span>Notes : </span> {supplierAddress?.delivery_notes} </li>
                                        )}
                                        <li><span>Ref : </span> {displayValue(supplierAddress?.reference_no)}</li>
                                        <li></li>

                                    </ul>
                                </div>
                                <div className="col-2">

                                </div>
                                <div className="col-3">
                                    <ul>
                                        <li><span>Gross Weight: {weights.gross_weight} KGS</span></li>
                                        <li><span>CBM: {weights.cbm} M3</span></li>
                                        <li><span>Net weight:{weights.net_weight} KGS</span></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className="text-center mt-4">
                <p className="lh-base">
                    <strong>Subject to Star Pacific terms and conditions of sale, a copy of which is available on request.</strong><br />
                    <strong>Star Pacific UK LTD (No. 7298396).</strong><br />
                </p>
                <hr />
                <p>
                    Reservation of Title. The property in and the title to all goods sold by Star Pacific shall not pass to the buyer until all monies due and owing have been paid in full
                </p>
            </footer>
        </div>
    );
};

export default PurchaseHistoryView;
